import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from '../../custom-components/QMentisBreadCrumb';
import DownloadIcon from '@mui/icons-material/Download';
import { Typography } from '@mui/material'
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import TestEnvironmentForm from '../../output-components/test-automation/TestEnvironment';
import TestCaseUI from '../../output-components/test-automation/TestCaseImported';
import Feature from '../../output-components/test-automation/FeatureFilesCreated';
import InputForm from '../../output-components/test-automation/PageSource';
import PageClass from '../../output-components/test-automation/PageClass';
import Locators from '../../output-components/test-automation/Locators';
import StepDefinition from '../../output-components/test-automation/StepDefinition';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import { ReactComponent as GenerateButton } from "../../../images/generateButton.svg";
import { featureFiles, pageClassAPI, stepDefinitionAPI } from '../../../services/webServices';
import { LoadingModalContext } from "../../main-pages/ServicePage";
import UploadBox from '../input-pages/UploadBox';
import { flattenArray, flattenObject } from "../../../utils/dataFlatteners";
import CommonDownload from "../../custom-components/CommonDownload";
import MessagePopup from '../../popup-components/MessagePopup';
import { set } from 'date-fns';
import BrowsePathPopup from '../../output-components/test-automation/BrowsePathPopup';

export const TestCaseFlowDataContext = createContext(null);

const PlayWrightCSharpNewTestCaseOutputPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [framework, setFramework] = useState("");
  const [projectType, setProjectType] = useState("");
  const [testEnvironment, setTestEnviorment] = useState({});
  const [testCase, setTestCase] = useState({});
  const [featureFile, setFeatureFile] = useState('');
  const [pageSource, setPageSource] = useState('');
  const [locator, setLocator] = useState('');
  const [pageClass, setPageClass] = useState('');
  const [stepDefinition, setstepDefinition] = useState('');
  const setLoading = useContext(LoadingModalContext);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [sessionExpiredValue, setSessionExpiredValue] = useState(false);
  const [gitPopupOpen, setGitPopupOpen] = useState(false);
  const [gitCredentails, setGitCredentails] = useState({})


  useEffect(() => {

    setFramework(location.state?.framework || "");
    setProjectType(location.state?.projectType || "");
    setTestEnviorment(location.state?.testenvironmentdata || {});
    setTestCase(location.state?.testCaseData || {});
    setFeatureFile(location.state?.featureFileData || "");
    setPageSource(location.state?.pageSource || "");
    setLocator(location.state?.generatedLocators || {});
    setPageClass(location.state?.generatedPageclassData || "");
    setstepDefinition(location.state?.generatedStepDefinitionData || "");
    setGitCredentails(location.state?.gitCredentials || {});
  },
    [
      location.state?.testenvironmentdata,
      location.state?.testCaseData,
      location.state?.featureFileData,
      location.state?.pageSource,
      location.state?.generatedLocators,
      location.state?.generatedPageclassData,
      location.state?.generatedStepDefinitionData,
      location.state?.framework,
      location.state?.projectType,
      location.state?.gitCredentials
    ])
  console.log(location.state?.framework);



  const breadCrumbs = [
   
    {
      title: "Test Case Details",
      status: Object.entries(testCase).length > 0
        ? "Completed"
        : Object.entries(testEnvironment).length === 0 
          ? "In Progress"
          : "Not Started",
    },
    {
      title: "Feature Files",
      status:
        !!featureFile && featureFile !== ""
          ? "Completed"
          : Object.entries(testCase).length > 0
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Introduce SUT",
      status:
        !!pageSource && pageSource !== ""
          ? "Completed"
          : (!!featureFile && featureFile !== "")
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "Generate Locators",
      status:
        Object.keys(locator).length > 0
          ? "Completed"
          : !!pageSource && pageSource !== ""
            ? "In Progress"
            : "Not Started",
    },
    // {
    //   title: "Page Class",
    //   status:
    //     !!pageClass && pageClass !== ""
    //       ? "Completed"
    //       : Object.keys(locator).length > 0
    //         ? "In Progress"
    //         : "Not Started",
    // },

    // {
    //   title: "Step Definition",
    //   status:
    //     (!!stepDefinition && stepDefinition !== "")
    //       ? "Completed"
    //       : !!pageClass && pageClass !== ""
    //         ? "In Progress"
    //         : "Not Started",
    // },
  ];

  const handleGenerateTestCases = async () => {
    setLoading(true)
    try {
      // Your API call to generate feature files
      const generatedFeatureFileResponse = await featureFiles(testCase);
      // Make sure to define testCasesData
      const generatedFeatureFile = generatedFeatureFileResponse.data;
      navigate(location.pathname, { state: { ...location.state, featureFileData: generatedFeatureFile }, replace: true })
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
    }
    finally {
      setLoading(false);
    }
  };


  const primaryFieldsObject = getPrimaryFields(locator);

  const handleGitHubProject = async () => {
    // setLoading(true);
    // try {
    //   const generatedPageClassGenerated = await pageClassAPI(primaryFieldsObject, location.state?.framework);
    //   const generatedPageClass = generatedPageClassGenerated.data;
    //   navigate(location.pathname, { state: { ...location.state, generatedPageclassData: generatedPageClass }, replace: true });
    // }
    // catch (error) {
    //   const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
    //   setPopupMessage(errorMsg);
    //   setPopupOpen(true);
    //   if (error.response?.data?.Error === "Your session has expired.") {
    //     setSessionExpiredValue(true);
    //   }
    // }
    // finally {
    //   setLoading(false);
    // }
    console.log("gitCredentails", gitCredentails);
    console.log("Sucessss popup");
    setGitPopupOpen(true);

  }
  const handleStepDefinition = async () => {
    setLoading(true);
    try {
      const pageClassData = {
        "pageClassGenerated": pageClass
      };
      const generatedStepDefinitionGenerated = await stepDefinitionAPI({ featureFileGenerated: featureFile, pageClassData }, location.state?.framework);
      const generatedStepDefinition = generatedStepDefinitionGenerated.data;
      navigate(location.pathname, { state: { ...location.state, generatedStepDefinitionData: generatedStepDefinition }, replace: true });
    }
    catch (error) {
      const errorMsg = error?.response?.data?.Error || "An error occurred. Please try again.";
      setPopupMessage(errorMsg);
      setPopupOpen(true);
      if (error.response?.data?.Error === "Your session has expired.") {
        setSessionExpiredValue(true);
      }
    }
    finally {
      setLoading(false);
    }

  }



  function getPrimaryFields(response) {
    const primaryFields = {};
    for (const key in response) {
      if (response[key].primary) {
        if (response[key].primary[0].startsWith("class")) {
          primaryFields[key] = response[key].secondary;
        } else {
          primaryFields[key] = response[key].primary;
        }
      }
    }
    return primaryFields;
  };
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };
  const testcaseNextButton = {
    label: "Generate Feature File",
    onClick: handleGenerateTestCases,
    startIcon: <GenerateButton />,
    variant: "contained",
    sx: { float: "right" },
  };

  const javaSeliniumDownloadButton = {
    label: "Download",
    onClick: handleDownloadClick,
    variant: "text",
    startIcon: <SaveAltRoundedIcon />,
    sx: { textTransform: "none" },
  };

  const locatorsNextButton = {
    label: "Update GitHub Project",
    variant: "contained",
    onClick: handleGitHubProject,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }
  const stepDefinitionNextButton = {
    label: "Generate Step Definition",
    variant: "contained",
    onClick: handleStepDefinition,
    startIcon: <GenerateButton />,
    sx: { float: "right" },
  }
  const handleCloseDownload = () => {
    setDownloadOpen(false);
  }
  const formatTestPlan = (testPlanData) => {
    const formattedTestPlan = {};
    Object.entries(testPlanData).map(([key, value]) => {
      // console.log(typeof value);
      // console.log(value)
      if (Array.isArray(value)) {
        return (formattedTestPlan[key] = flattenArray(value));
      }
      if (!!value && typeof value === "object") {
        return (formattedTestPlan[key] = flattenObject(value));
      }
      return (formattedTestPlan[key] = value);
    });
    // console.log(formattedTestPlan)
    return formattedTestPlan;
  };




  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
      }}
    >

      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0", // Adjust this value as needed to place the breadcrumb where you want it
            width: "100%",
            zIndex: 1000, // Ensure it stays above other content
            bgcolor: "white", // Background color to prevent transparency
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", // Optional shadow for visual separation
          }}
        >


          <QMentisBreadCrumb breadCrumbs={breadCrumbs} sx={{ height: "56px" }} />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate automated test scripts
                </Typography>
              </Box>
              <FullscreenToggle />




            </Box>
            {/* JAVA SELENIUM COMPONENTS */}
            {/* {Object.entries(testEnvironment).length === 0 && ( */}
              {/* <TestEnvironmentForm *
                testEnvironmentData={testEnvironment}
                setTestEnviorment={setTestEnviorment}
                framework={location.state?.framework}
                confirmed={confirmed}
                setConfirmed={setConfirmed}
                projectType={projectType}
              />
            {/* )} */}

            {/* <UploadBox testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} /> */}
          
              <UploadBox
                testCaseData={testCase}
                setTestCase={setTestCase}
                testcaseNextButton={testcaseNextButton}
                javaSeliniumDownloadButton={javaSeliniumDownloadButton}
              />
            
            {Object.entries(testCase).length > 0 && <TestCaseUI testCaseData={testCase} setTestCase={setTestCase} testcaseNextButton={testcaseNextButton} javaSeliniumDownloadButton={javaSeliniumDownloadButton} projectType={projectType} gitCredentails={gitCredentails} />}
            {!!featureFile && featureFile !== "" && <Feature featureFile={featureFile} setFeatureFile={setFeatureFile} projectType={projectType} gitCredentails={gitCredentails}/>}
            {!!featureFile && featureFile !== "" && <InputForm setPageSource={setPageSource} projectType={projectType} gitCredentails={gitCredentails}/>}
            {Object.entries(locator).length > 0 && <Locators locator={locator} setLocator={setLocator} locatorsNextButton={locatorsNextButton} projectType={projectType} gitCredentails={gitCredentails}/>}
            {/* {!!pageClass && pageClass !== "" && <PageClass pageClass={pageClass} setPageClass={setPageClass} featureFile={featureFile} stepDefinitionNextButton={stepDefinitionNextButton} projectType={projectType} />}
            {!!stepDefinition && stepDefinition !== "" && <StepDefinition stepDefinition={stepDefinition} setstepDefinition={setstepDefinition} featureFile={featureFile} pageClass={pageClass} framework={location.state?.framework} gitCredentails={gitCredentails} projectType={projectType}/>} */}
          </Box>
        </Box>
        {/* Add padding-top to avoid overlap with the fixed breadcrumb */}
        <Container
          sx={{
            // paddingTop: "50px", // Adjust this value based on the height of the breadcrumb
            width: "100%",
          }}
        >


          {/* <TestCaseFlowDataContext.Provider
            value={{
              testCaseDetails,
              setTestCaseDetails,
              featureFiles,
              setFeatureFiles,
              pageSources,
              setPageSources,
              locators,
              setLocators,
              pageClasses,
              setPageClasses,
              stepDefinitions,
              setstepDefinitions,

            }}
          > */}


          {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}>
              <Button
                startIcon={<DownloadIcon />}
                color="#80c3d8"
                sx={{ textTransform: "none", marginRight: '15px', color: '#53adcb', border: '2px solid #53adcb', }}
              >
                Upload
              </Button>
            </Box> */}



          {/* </TestCaseFlowDataContext.Provider> */}
        </Container>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI tools.
        </Typography>
      </Box>
      <MessagePopup
        modalOpen={popupOpen}
        okayHandler={() => setPopupOpen(false)}
        message={popupMessage}
      />
      <CommonDownload open={downloadOpen} onClose={handleCloseDownload}
        wordData={[
          {
            type: "subParagraphs",
            data: testCase,
          },
        ]}
        serviceName={"Test Case Details"}
        serviceResponse={formatTestPlan(testCase)}
        documents={['xls', 'csv']}
      />
        <BrowsePathPopup
        open={gitPopupOpen}
        handleClose={() => setGitPopupOpen(false)}
        text1={"Congratulations! Your PlayWright C Sharp project has been successfully updated."}
       />
    </Box>
    
  );
};


export default PlayWrightCSharpNewTestCaseOutputPage;